/* eslint-disable react-hooks/exhaustive-deps */
import * as faceapi from 'face-api.js'
import {
	Container,
	Flex,
	HStack,
	Modal,
	ModalOverlay,
	ModalContent,
	ModalBody,
	Skeleton,
	VStack,
	Text,
	Button,
	Box,
	useDisclosure,
	useToast,
} from '@chakra-ui/react'
import * as moment from 'moment'
import React, { useState, useCallback, useEffect } from 'react'
import { useHistory } from 'react-router'
import Navbar from '../components/navbar'
import Sidebar from '../components/sidebar'
import { useAuthContext } from '../context/auth.context'
import ReactCountdownClock from 'react-countdown-clock'
import { SharedContextProvider } from '../context/shared.context'
import { SidebarContextProvider } from '../context/sidebar.context'

import {
	useLoadAssetInlineCollection,
	useLoadAwsBucketName,
	useLoadAssetAuthToken,
	useAddTimeSheetData,
} from '../hooks/asset.hooks'
import { useLoadS3Creds } from '../hooks/shared.hooks'
import { loginConst } from '../utils/action.constant'
import {
	getLocalAuthDetails,
	setLocalAuthDetails,
	getISTtoUTC,
} from '../utils/common.util'
import { useLogOut, useLastSeenUpdate } from '../hooks/login.hooks'
import Sound from 'react-sound'
import notificationTone from '../assets/ringtones/notification.mp3'
import { usePubNub } from 'pubnub-react'
import { TIMELINE_MESSAGE_TYPE } from '../components/timeline/util'
import { useLanguageContext } from '../context/locale.context'
import { sectionDetailedTrack } from '../containers/repository/repo.utils'
import { GA_CATEGORY_DIALOG_BOX } from './../containers/repository/repo.utils'
import { useDeepStreamContext } from '../context/deepstream.context'

const timer = 20

const PrivateLayout = ({ children }) => {
	const pubnub = usePubNub()
	const [user, setUser] = useState(null)
	const [away, setIsAway] = useState(null)

	const history = useHistory()
	const toast = useToast({
		duration: 1000,
	})
	const { dispatch } = useAuthContext()
	const {
		state: { locale },
	} = useLanguageContext()
	const {
		state: { ds },
	} = useDeepStreamContext()
	const { mutate, isLoading } = useLoadAssetInlineCollection()
	const { mutate: loadBucketMutate } = useLoadAwsBucketName()
	const { mutate: addTimeSheetMutate } = useAddTimeSheetData()
	const { mutate: mutateS3Creds } = useLoadS3Creds()
	const { mutate: mutateLoadAssetAuthToken } = useLoadAssetAuthToken()
	const { mutate: mutatelogOut } = useLogOut()
	const { mutate: lastSeenMutate } = useLastSeenUpdate()
	const {
		isOpen: isTimerOpen,
		onClose: onTimerClose,
		onOpen: onTimerOpen,
	} = useDisclosure()
	const [showSessionTimer, setShowSessionTimer] = useState(false)
	const [sessionTime, setSessionTime] = useState(1800)
	const [stream, setStream] = useState(null)
	const [playStatus, setPlayStatus] = useState(Sound.status.STOPPED)

	const loadBucketName = useCallback(() => {
		loadBucketMutate(
			{},
			{
				onSuccess: async res => {
					if (res.data.status === 200) {
						const { bucket_name } = res.data.response[0]
						if (!!bucket_name) {
							dispatch({
								type: loginConst.SET_BUCKET_NAME,
								bucket_name,
							})
						}
					} else {
						console.log('Error Occured!', res)
					}
				},
			}
		)
	})

	const stopVideoFeed = () => {
		if (!!stream) {
			stream.getVideoTracks().forEach(track => {
				track.stop()
			})
		}
	}

	const setAwayStatus = async status => {
		try {
			// console.log('PL: SETAWAY STATUS ', status)
			await pubnub.publish({
				channel: `${user.organization_id}`,
				message: {
					myDevice: 'Desktop',
					status: status ? 'Away' : false,
					onVideoCall: false,
					onPhoneCall: false,
					isDND: false,
					lat: user.asset_last_seen_location_latitude,
					lon: user.asset_last_seen_location_longitude,
				},
			})
		} catch (err) {
			console.log('PL: SETAWAY STATUS ', err)
		}
	}

	const pointerInHandler = () => {
		setShowSessionTimer(false)
		setSessionTime(1800)
	}

	const pointerOutHandler = () => {
		setShowSessionTimer(true)
	}

	const triggerLogoutPopup = () => {
		setShowSessionTimer(false)
		setPlayStatus(Sound.status.PLAYING)
		onTimerOpen()
	}

	const closeTimerModal = () => {
		setShowSessionTimer(false)
		setPlayStatus(Sound.status.STOPPED)
		onTimerClose()
		initiateFaceDetector()
	}

	const checkUserPresence = async timeoutId => {
		const video = document.getElementById('userCameraView')
		if (!video) {
			return
		}
		const detections = await faceapi
			.detectAllFaces(video, new faceapi.TinyFaceDetectorOptions())
			.withFaceLandmarks()
		if (detections.length > 0) {
			setAwayStatus(false)
			setIsAway(false)
			pointerInHandler()
			clearTimeout(timeoutId)
			timeoutId = 0
		} else if (!timeoutId) {
			timeoutId = setTimeout(() => {
				setAwayStatus(true)
				setIsAway(true)
				pointerOutHandler()
				clearTimeout(timeoutId)
			}, 10000)
		}
		setTimeout(() => {
			checkUserPresence(timeoutId)
		}, 300000) // 5 Min
	}

	const onVideoPlayListner = () => {
		checkUserPresence(0)
		const video = document.getElementById('userCameraView')
		if (!!video) {
			setInterval(async () => {
				const detections = await faceapi
					.detectAllFaces(video, new faceapi.TinyFaceDetectorOptions())
					.withFaceLandmarks()
				if (!!video && detections.length > 0) {
					addTimeSheetMutate(
						{
							start_datetime: moment().utc().format(),
							end_datetime: moment().utc().format(),
							work_hours_duration: 10,
							swipe_type_id: 1,
							flag: 0,
						},
						{
							onSuccess: async data => {
								// console.log('timesheet update', data);
							},
						}
					)
				}
			}, 600000) /// updating the timesheet on every 10mins
		}
	}

	const startFaceDetectorVideo = () => {
		const video = document.getElementById('userCameraView')
		if (!!video) {
			let sbrowser = navigator.userAgent
			if (sbrowser.indexOf('Firefox') > -1) {
				toast({
					title: 'Failed!',
					description: `Chrome browser is compatible for all features in GreneOS Virtual
          Office, please download one of the free browsers listed below
          \n Chrome(version 84 or higher)
          \n
          MS Edge(version 84 or higher)
          \n
          Safari(version 12 or higher)`,
					status: 'error',
				})
			} else {
				navigator.mediaDevices
					.getUserMedia({
						video: {
							frameRate: { ideal: 10, max: 15 },
							height: { ideal: 360 },
						},
						audio: false,
					})
					.then(stream => {
						video.srcObject = stream
						setStream(stream)
					})
					.catch(err => console.error('error on user cam stream output', err))
			}
		}
	}

	const initiateFaceDetector = useCallback(() => {
		Promise.all([
			faceapi.nets.tinyFaceDetector.loadFromUri('/models'),
			faceapi.nets.faceLandmark68Net.loadFromUri('/models'),
		])
			.then(() => startFaceDetectorVideo())
			.catch(error => {
				console.log('error occurred on promise resolve', error)
			})
	}, [])

	const loadUserDetails = useCallback(data => {
		const payload = getLocalAuthDetails()
		mutate(
			{ ...payload },
			{
				onSuccess: async res => {
					if (res.data.status === 200) {
						const userData = res.data.response.data
						localStorage.setItem(
							'ORGANIZATION_ONHOLD',
							userData && userData.organization_flag_dashboard_onhold
						)
						if (userData.organization_flag_timeline_filter === 1) {
							localStorage.setItem(
								'timelineFilter',
								JSON.stringify({
									value: TIMELINE_MESSAGE_TYPE.ALL,
									label: locale['All'],
								})
							)
						} else {
							localStorage.setItem(
								'timelineFilter',
								JSON.stringify({
									value: TIMELINE_MESSAGE_TYPE.DEFAULT,
									label: 'Default',
								})
							)
						}
						if (
							!!userData &&
							(userData.workforce_flag_enable_web_access === 0 ||
								userData.organization_enterprise_features_enabled === 0)
						) {
							dispatch({
								type: loginConst.LOGOUT,
							})
							history.push('/login?access=false')
						}
						setUser(userData)
						if (!!userData.organization_inline_data) {
							userData.organization_file_templates = JSON.parse(
								userData.organization_inline_data
							).organization_file_templates
						}
						if (
							!userData.asset_token_auth &&
							!userData.asset_encryption_token_id
						) {
							mutateLoadAssetAuthToken(
								{ userData },
								{
									onSuccess: data => {
										setLocalAuthDetails(data)
										let {
											asset_token_auth = '',
											asset_encryption_token_id = '',
										} = data
										lastSeenMutate({
											organization_id: data.organization_id,
											asset_id: data.asset_id,
											location_datetime: getISTtoUTC(),
											asset_token_auth:
												asset_token_auth || asset_encryption_token_id,
										})
										dispatch({
											type: loginConst.SAVE_USER_AUTH,
											payload: data,
										})
									},
								}
							)
						} else {
							setLocalAuthDetails(userData)
							let { asset_token_auth = '', asset_encryption_token_id = '' } =
								userData
							lastSeenMutate({
								organization_id: userData.organization_id,
								asset_id: userData.asset_id,
								asset_token_auth: asset_token_auth || asset_encryption_token_id,
								location_datetime: getISTtoUTC(),
							})
							dispatch({
								type: loginConst.SAVE_USER_AUTH,
								payload: userData,
							})
						}
						initiateFaceDetector()
						loadBucketName()
						mutateS3Creds({})
					} else {
						console.log('Something went wrong please login again!')
					}
				},
				onError: async err => {
					console.log('Something went wrong please login again!', err)
					// dispatch({
					//   type: loginConst.LOGOUT,
					// });
					// history.push('/login');
				},
			}
		)
	})

	const handleLogout = () => {
		mutatelogOut(
			{},
			{
				onSuccess: () => {
					dispatch({
						type: loginConst.LOGOUT,
					})
					stopVideoFeed()
					history.push('/login')
				},
			}
		)
	}

	useEffect(() => {
		loadUserDetails()
	}, [])

	return (
		<>
			{children.props.path === '/idcardscreen' ||
			children.props.path === '/idcard' ||
			children.props.path === '/sharecontact' ? (
				<Container
					h='100vh'
					minW={'100vw'}
					m={0}
					p={0}
					display={'Flex'}
					onPointerEnter={() => pointerInHandler()}
					onPointerLeave={() => pointerOutHandler()}
				>
					<SharedContextProvider>
						<Navbar
							handleLogout={handleLogout}
							onVideoPlayListner={onVideoPlayListner}
							sessionTime={sessionTime}
							triggerLogoutPopup={triggerLogoutPopup}
							showSessionTimer={showSessionTimer}
						/>
						<Flex flex={1} justifyContent='flex-start'>
							<Container maxW='100%' width='100%' px='0px'>
								{children}
							</Container>
						</Flex>
						<Modal isOpen={isTimerOpen} onClose={closeTimerModal}>
							<ModalOverlay />
							<ModalContent>
								<ModalBody>
									<Flex flexDirection='column' align='center'>
										<ReactCountdownClock
											seconds={timer}
											color='#707070'
											alpha={0.9}
											weight={30}
											size={200}
											onComplete={handleLogout}
										/>
										<Text mt={3} mb={3}>
											{locale['Are you still available?']}
										</Text>
										<Button
											colorScheme='green'
											onClick={() => {
												sectionDetailedTrack({
													category: GA_CATEGORY_DIALOG_BOX,
													action: 'Close Timer Modal',
												})
												closeTimerModal()
											}}
										>
											{locale['Continue']}
										</Button>
									</Flex>
								</ModalBody>
							</ModalContent>
						</Modal>
						<Sound
							url={notificationTone}
							playStatus={playStatus}
							loop={true}
							autoLoad={true}
						/>
					</SharedContextProvider>
				</Container>
			) : (
				<Container
					h='100vh'
					minW={'100vw'}
					m={0}
					p={0}
					display={'Flex'}
					onPointerEnter={() => pointerInHandler()}
					onPointerLeave={() => pointerOutHandler()}
				>
					<SharedContextProvider>
						<Navbar
							handleLogout={handleLogout}
							onVideoPlayListner={onVideoPlayListner}
							sessionTime={sessionTime}
							triggerLogoutPopup={triggerLogoutPopup}
							showSessionTimer={showSessionTimer}
						/>
						<HStack
							spacing={1}
							marginTop='60px'
							width='100vw'
							h='calc(100vh - 60px)'
							alignItems='flex-start'
						>
							<SidebarContextProvider>
								<Sidebar />
							</SidebarContextProvider>
							<Flex flex={1} justifyContent='flex-start'>
								<Container maxW='100%' width='100%' my={4} mx={0} px={0}>
									{children}
								</Container>
							</Flex>
						</HStack>
						<Modal isOpen={isTimerOpen} onClose={closeTimerModal}>
							<ModalOverlay />
							<ModalContent>
								<ModalBody>
									<Flex flexDirection='column' align='center'>
										<ReactCountdownClock
											seconds={timer}
											color='#707070'
											alpha={0.9}
											weight={30}
											size={200}
											onComplete={handleLogout}
										/>
										<Text mt={3} mb={3}>
											{locale['Are you still available?']}
										</Text>
										<Button
											colorScheme='green'
											onClick={() => {
												sectionDetailedTrack({
													category: GA_CATEGORY_DIALOG_BOX,
													action: 'Close Timer Modal',
												})
												closeTimerModal()
											}}
										>
											{locale['Continue']}
										</Button>
									</Flex>
								</ModalBody>
							</ModalContent>
						</Modal>
						<Sound
							url={notificationTone}
							playStatus={playStatus}
							loop={true}
							autoLoad={true}
						/>
					</SharedContextProvider>
				</Container>
			)}
		</>
	)
}

export default PrivateLayout
